/** Tokens do Design System Web [Coordly] usados no chat de IA (Figma "Chat IA Web v26"). */
export const colors = {
  surface: '#FFFFFF',
  surfaceContainer: '#F7F7F7',
  surfaceOutline: '#EAEDF0',
  onSurface: '#324150',
  onSurfaceVariant: '#8697A8',
  onSurfacePlaceholder: '#BEC2C6',
  onSurfaceHover: 'rgba(50, 65, 80, 0.12)',
  secondary: '#EAEDF0',
  onSecondary: '#324150',
  primary: '#3547C8',
  onPrimary: '#FFFFFF',
  danger: '#E2574C',
  overlay: 'rgba(0, 0, 0, 0.5)',
  aiPink: '#FC466B',
  aiBlue: '#3F5EFB'
};

export const fontFamily = "'Open Sans', sans-serif";

export const aiPanelShadow =
  '6px 6px 56px 0px rgba(63, 94, 251, 0.24), -6px -6px 56px 0px rgba(252, 70, 107, 0.24)';

export const menuShadow =
  '0px 16px 24px 0px rgba(0, 0, 0, 0.07), 0px 2px 6px 0px rgba(0, 0, 0, 0.1)';

export const PANEL_GAP = 16;
export const SIDEBAR_WIDTH = 254;
export const CHAT_WIDTH = 512;
